export interface IProductSubCategory {
  name: string;
  description: string;
  imgSrc?: string;
}

export interface IProductCategory {
  name: string;
  description: string;
  imgSrc: string;
  subCategories: IProductSubCategory[];
}

export const productCategoryInitialState: IProductCategory[] = [
  {
    name: "Supplements",
    description: "Daily wellness, energy & vitality support.",
    imgSrc: require("../../assets/images/product-categories/supplements-adults.webp"),
    subCategories: [
      {
        name: "Adult Supplements",
        description:
          "Nutritional supplements designed to support adult wellness, nutritional needs and overall health",
      },
      {
        name: "Children Supplements",
        description:
          "Nutritional supplements formulated to support children’s nutritional needs, growth and development.",
      },
    ],
  },
  {
    name: "Skincare",
    description: "Medical-grade routines for healthy-looking skin.",
    imgSrc: require("../../assets/images/product-categories/skincare.webp"),
    subCategories: [
      {
        name: "Cleansers",
        description:
          "Gentle cleansing products to remove dirt, oil and impurities from the face and body.",
      },
      {
        name: "Body Lotions",
        description:
          "Nourishing body care products that help moisturize, soften and maintain healthy-looking skin.",
      },
      {
        name: "Serums & Toners",
        description:
          "Targeted skincare products designed to hydrate, brighten and improve the appearance of skin",
      },
      {
        name: "Sunscreen",
        description:
          "Sun protection products that help protect the skin from harmful UV rays and sun damage.",
      },
    ],
  },
  {
    name: "Postpartum Care",
    description: "Nurturing recovery for new mothers.",
    imgSrc: require("../../assets/images/product-categories/post-partum-care.webp"),
    subCategories: [
      {
        name: "Postpartum care kits",
        description: "Complete recovery sets for the fourth trimester.",
      },
      {
        name: "Perineal & Cooling pads",
        description: "Immediate soothing relief for vaginal recovery.",
      },
      {
        name: "Witch hazel products",
        description: "Natural astringents for gentle healing and comfort.",
      },
      {
        name: "Breastfeeding & Motherhood",
        description: "Support items for lactation and maternal wellness.",
      },
      {
        name: "C-Section Recovery",
        description:
          "Specialized care for abdominal incision healing and comfort.",
      },
    ],
  },
];
